<!-- // -----------------------------------------------------------------------------
// <copyright file="custom-warning.component.html" company="ecoInsight, Inc.">
// 	Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------ -->
<div class="warn-msg {{ data?.infoMessage ? 'info-msg' : '' }}">
  @if (!data?.infoMessage) {
    <div class="ic">
      <i class="{{ data?.icon ? data?.icon : 'i-warn-n' }}"></i>
    </div>
  }
  <div class="cnt">
    <span>{{ data?.message | translate }}</span>
    @if (data?.message2) {
      <span
        >{{ data?.message2 | translate }}
        @if (data?.boldMessage2) {
          <strong>{{ data?.boldMessage2 }}</strong>
        }
      </span>
    }
  </div>
</div>
<div class="sub-titles">
  @if (data?.fgWarn) {
    <ol class="spo-warn">
      @for (err of data?.bomtypeErrList ?? []; track err) {
        <li>{{ err }}</li>
      }
    </ol>
  }
  @if (data?.spoFieldWarn) {
    <ol class="spo-warn">
      <li>
        <span>{{ 'pm.coqty' | translate }}:</span>{{ 'pm.errqv' | translate }}
      </li>
      <li>
        <span>{{ 'q.prt' | translate }}:</span>{{ 'pm.cbb' | translate }}
      </li>
      <li>
        <span>{{ 'q.uc' | translate }}:</span>{{ 'pm.errupv' | translate }}
      </li>
      <li>
        <span>{{ 'q.us' | translate }}:</span>{{ 'pm.errupvc' | translate }}
      </li>
    </ol>
  }
  @if (data?.copWarnList?.length) {
    <ol class="spo-warn">
      @if (data?.copWarnList?.includes('HasBillAndHoldConflict')) {
        <li>{{ 'os.coperr1' | translate }}</li>
      }
      @if (data?.copWarnList?.includes('HasCPOConflict')) {
        <li>{{ 'os.coperr2' | translate }}</li>
      }
      @if (data?.copWarnList?.includes('HasRFPConflict')) {
        <li>{{ 'os.coperr3' | translate }}</li>
      }
      @if (data?.copWarnList?.includes('HasSPOConflict')) {
        <li>{{ 'os.coperr4' | translate }}</li>
      }
    </ol>
  }
  @if (data?.cpoWarnList?.length) {
    <ol class="spo-warn">
      @if (data?.cpoWarnList?.includes('amountNotMatched')) {
        <li>{{ 'po.cpoerr1' | translate }}</li>
      }
      @if (data?.cpoWarnList?.includes('rowsWithNoQty')) {
        <li>{{ 'po.cpoerr2' | translate }}</li>
      }
      @if (data?.cpoWarnList?.includes('rowsWithNoCost')) {
        <li>{{ 'po.cpoerr3' | translate }}</li>
      }
      @if (data?.cpoWarnList?.includes('lotsWithNoExtCost')) {
        <li>{{ 'po.cpoerr4' | translate }}</li>
      }
      @if (data?.cpoWarnList?.includes('lotsWithNoProducts')) {
        <li>{{ 'po.cpoerr5' | translate }}</li>
      }
      @if (data?.cpoWarnList?.includes('hasMissingMFRBudget')) {
        <li>{{ 'po.cpoerr6' | translate }}</li>
      }
      @if (data?.cpoWarnList?.includes('hasDuplicateMFRBudget')) {
        <li>{{ 'po.cpoerr7' | translate }}</li>
      }
      @if (data?.cpoWarnList?.includes('lotsWithNoDesc')) {
        <li>{{ 'po.cpoerr8' | translate }}</li>
      }
    </ol>
  }
</div>

<div class="warn-footer">
  @if (data?.showCheckBox) {
    <div class="dns-check">
      @if (!isDntShowClicked) {
        <i tabindex="0" role="button" class="i-ucheck-b" (click)="isDntShowClicked = true"></i>
      }
      @if (isDntShowClicked) {
        <i
          tabindex="0"
          role="button"
          class="i-checkbox-active"
          (click)="isDntShowClicked = false"
        ></i>
      }
      <span>{{ data?.checkBoxMsg ? data?.checkBoxMsg : ('pr.dnsa' | translate) }}</span>
    </div>
  }
  <div class="action">
    @if (data?.infoMessage) {
      @if (data?.btnTxt1) {
        <vs-button
          class="mr-2"
          [className]="'primary'"
          [text]="data?.btnTxt1 ? (data?.btnTxt1 | translate) : ('p.c' | translate)"
          (onClick)="onConfirm()"
          data-testid="warn-canl-btn"
        ></vs-button>
      }
    } @else {
      @if (data?.btnTxt1) {
        <vs-button
          class="mr-2"
          [className]="'plain'"
          [text]="data?.btnTxt1 ? (data?.btnTxt1 | translate) : ('p.c' | translate)"
          (onClick)="onCancel()"
          data-testid="warn-canl-btn"
        ></vs-button>
      }
      @if (data?.btnTxt2) {
        <vs-button
          class="mr-2"
          [className]="'primary'"
          [text]="data?.btnTxt2 ? (data?.btnTxt2 | translate) : ('cm.ok' | translate)"
          (onClick)="onConfirm()"
          data-testid="warn-cnfrm-btn"
        ></vs-button>
      }
      @if (data?.btnTxt3) {
        <vs-button
          [className]="'primary'"
          [text]="data?.btnTxt3 ? (data?.btnTxt3 | translate) : ('cm.ok' | translate)"
          (onClick)="onSecondConfirm()"
          data-testid="warn-cnfrm-btn"
        ></vs-button>
      }
    }
  </div>
</div>
